/** Helpers for both apps' page policies (apps/web's is an allowlist, never a
 *  denylist: see CLAUDE.md #45). fbevents.js sends the page URL AND
 *  `document.referrer` with every event, so policies check both. */

/** Every route also renders at `/x/` (`skipTrailingSlashRedirect`). */
export function normalizePathname(pathname: string): string {
  return pathname.replace(/\/+$/, "") || "/";
}

/** True when `referrer` is safe to send with `pageHref`. None or cross-origin
 *  is safe; a same-origin one can name an excluded page, so it must pass
 *  `allowsSameOrigin`. Unparseable input fails closed. */
export function isReferrerAllowed(
  referrer: string,
  pageHref: string,
  allowsSameOrigin: (referrer: URL) => boolean,
): boolean {
  if (!referrer) return true;
  let ref: URL;
  let page: URL;
  try {
    ref = new URL(referrer);
    page = new URL(pageHref);
  } catch {
    return false;
  }
  if (ref.origin !== page.origin) return true;
  return allowsSameOrigin(ref);
}
